import React, { useEffect } from 'react';
import Navbar from '../global/Navbar';
import Footer from '../global/Footer';
import PageMeta from '../shared/PageMeta';
import { UPDATES_AS_OF } from '../../../content/snowflakeUpdates';
import { applyPublicShellHead } from '../../../content/seoMeta';

export function ExternalLink({ href, children }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="font-medium text-brand-700 underline decoration-brand-400 underline-offset-2 hover:text-brand-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-700"
    >
      {children}
      <span className="sr-only"> (opens in a new tab)</span>
    </a>
  );
}

export function SourcesList({ sources }) {
  return (
    <section aria-labelledby="update-sources" className="mt-12 border-t border-ink-200 pt-8">
      <h2 id="update-sources" className="font-display text-xl font-semibold text-brand-900">
        Sources
      </h2>
      <ul className="mt-4 space-y-2">
        {sources.map((source) => (
          <li key={source.href}>
            <ExternalLink href={source.href}>{source.label}</ExternalLink>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-sm text-ink-500">
        Snowflake and Cortex are trademarks of Snowflake Inc.; MyOrgLab is not affiliated.
      </p>
    </section>
  );
}

export default function UpdateLayout({
  path,
  title,
  children,
  sources,
  asOf = UPDATES_AS_OF,
  chip = 'Snowflake updates',
  eyebrow,
}) {
  useEffect(() => applyPublicShellHead(path), [path]);

  return (
    <div>
      <PageMeta path={path} />
      <Navbar />
      <main className="bg-white">
        <article className="updates-mobile-pad container-x py-14 sm:py-20">
          <span className="updates-chip inline-flex rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide">
            {chip}
          </span>
          {eyebrow ? <p className="eyebrow mt-3">{eyebrow}</p> : null}
          <h1 className="mt-3 max-w-3xl text-balance font-display text-4xl font-semibold tracking-tight text-brand-900 sm:text-5xl">
            {title}
          </h1>
          <p className="mt-4 text-sm font-medium text-ink-500">As of {asOf}</p>
          <div className="updates-article mt-8 max-w-3xl space-y-5 text-base leading-relaxed text-ink-700">
            {children}
          </div>
          <SourcesList sources={sources} />
          <p className="mt-10">
            <a
              href="/updates"
              className="text-sm font-medium text-brand-700 underline decoration-brand-400 underline-offset-2 hover:text-brand-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-700"
            >
              All Snowflake updates
            </a>
          </p>
        </article>
      </main>
      <Footer />
    </div>
  );
}
